import { render, staticRenderFns } from "./create-product-name.vue?vue&type=template&id=ec39c3ee"
import script from "./create-product-name.vue?vue&type=script&lang=ts"
export * from "./create-product-name.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports